import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import CharacterSheetModifier from './CharacterSheetModifier.vue';
import CharacterSheetTweaker from './CharacterSheetTweaker.vue';
import CharacterSheetWeapon from './CharacterSheetWeapon.vue';
import CharacterSheetSuperiority from './CharacterSheetSuperiority.vue';
import CharacterSheetExpansionFeatures from './CharacterSheetExpansionFeatures.vue';
import CharacterSheetCustomFeatures from './CharacterSheetCustomFeatures.vue';
import CharacterSheetCustomFeats from './CharacterSheetCustomFeats.vue';
let CharacterSheetCombat = class CharacterSheetCombat extends Vue {
    constructor() {
        super(...arguments);
        this.weaponTweakPaths = [
            { name: 'To Hit', path: 'weapon.toHit' },
            { name: 'Damage Bonus', path: 'weapon.damage' }
        ];
    }
};
__decorate([
    Prop(Number)
], CharacterSheetCombat.prototype, "proficiencyBonus", void 0);
__decorate([
    Prop(Number)
], CharacterSheetCombat.prototype, "initiative", void 0);
__decorate([
    Prop(Number)
], CharacterSheetCombat.prototype, "armorClass", void 0);
__decorate([
    Prop(Array)
], CharacterSheetCombat.prototype, "armorList", void 0);
__decorate([
    Prop(Object)
], CharacterSheetCombat.prototype, "speed", void 0);
__decorate([
    Prop(Array)
], CharacterSheetCombat.prototype, "equipment", void 0);
__decorate([
    Prop(Array)
], CharacterSheetCombat.prototype, "customEquipment", void 0);
__decorate([
    Prop(Array)
], CharacterSheetCombat.prototype, "weapons", void 0);
__decorate([
    Prop(Number)
], CharacterSheetCombat.prototype, "passivePerception", void 0);
__decorate([
    Prop({ type: [Boolean, Object] })
], CharacterSheetCombat.prototype, "superiority", void 0);
__decorate([
    Prop(Array)
], CharacterSheetCombat.prototype, "combatFeatures", void 0);
__decorate([
    Prop(Array)
], CharacterSheetCombat.prototype, "customFeatures", void 0);
__decorate([
    Prop(Number)
], CharacterSheetCombat.prototype, "numCustomFeats", void 0);
__decorate([
    Prop(Object)
], CharacterSheetCombat.prototype, "tweaks", void 0);
CharacterSheetCombat = __decorate([
    Component({
        components: {
            CharacterSheetModifier,
            CharacterSheetTweaker,
            CharacterSheetWeapon,
            CharacterSheetSuperiority,
            CharacterSheetExpansionFeatures,
            CharacterSheetCustomFeatures,
            CharacterSheetCustomFeats
        }
    })
], CharacterSheetCombat);
export default CharacterSheetCombat;
